import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { File } from '@ionic-native/file';
import { AnalyticsProvider } from '../providers/analytics/analytics';
import { CameraOptions, Camera } from '@ionic-native/camera';
import { TranslateService } from '@ngx-translate/core';
declare const greatdayplugin;

export interface ResponseGeolocationCameraRadiusPlugin {
  address: string;
  latitude: string;
  longitude: string;
  mock: boolean;
  native: boolean;
  path: string;
}
export interface ResponseCameraPlugin {
  mock: boolean;
  native: boolean;
  path: string;
}
export interface GDIGeolocationCamera {
  camera: GDICamera;
  geolocation: GDIGeolocation;
  cancelled: boolean;
}

export interface GDICamera {
  nativeURL?: string;
  base64Image?: string;
  cancelled?: boolean;
}
export interface GDIGeolocation {
  latitude?: any;
  longtitude?: any;
  cancelled?: boolean;
  mock?: boolean;
  address?: string;
}

export class GDNativeResponse {
  public response = {
    camera: {
      nativeURL: "",
      base64Image: ""
    },
    geolocation: {
      latitude: 0,
      longitude: 0,
      mock: false,
      address: ""
    },
    cancelled: false
  }
}

@Injectable()
export class GreatdayPluginNative {
  // default camera
  private quality = "75";
  private maxSize = "1920";
  constructor(
    public http: HttpClient,
    public file: File,
    private analyticsProvider: AnalyticsProvider,
    private camera: Camera,
    private translate: TranslateService,
  ) {
  }

  getGDCamera(fileName: string = 'img_gd'): Promise<GDIGeolocationCamera> {
    return new Promise((resolve, reject) => {
      let data = {
        camera: {
          nativeURL: "",
          base64Image: ""
        },
        geolocation: {
          latitude: 0,
          longitude: 0,
          mock: false,
        },
        cancelled: false
      }

      greatdayplugin.getCamera(fileName, this.quality, this.maxSize, async (response: ResponseCameraPlugin) => {
        console.log('TCL: getGDCamera', response);
        if (response.native) {
          const cameraDevice = await this.cameraDevice({ sourceType: this.camera.PictureSourceType.CAMERA });
          data.camera.nativeURL = cameraDevice.nativeUrl;
          data.camera.base64Image = cameraDevice.base64Image;
          data.cancelled = cameraDevice.cancelled;
        } else {
          const resolvedImageData = await this.file.resolveLocalFilesystemUrl("file://" + response.path);
          const filename = resolvedImageData.nativeURL.substring(resolvedImageData.nativeURL.lastIndexOf('/') + 1);
          const path = resolvedImageData.nativeURL.substring(0, resolvedImageData.nativeURL.lastIndexOf('/') + 1);
          const base64Image = await this.file.readAsDataURL(path, filename);

          data.camera.nativeURL = resolvedImageData.nativeURL;
          data.camera.base64Image = base64Image;
        }

        console.log('getGDCamera ', response);
        resolve(data);
      }, (error) => {
        data.cancelled = true;
        resolve(data)
      })
    })
  }

  getCameraSwap(): Promise<GDICamera> {
    return new Promise((resolve, reject) => {
      let data = {
        nativeURL: "",
        base64Image: "",
        cancelled: false
      }

      greatdayplugin.getCameraSwap("img_gd", this.quality, this.maxSize, async (response: ResponseCameraPlugin) => {
        console.log('TCL: getCameraSwap', response);
        if (response.native) {
          const cameraDevice = await this.cameraDevice({ sourceType: this.camera.PictureSourceType.CAMERA });
          data.base64Image = cameraDevice.base64Image;
          data.nativeURL = cameraDevice.nativeUrl;
          data.cancelled = cameraDevice.cancelled;
        } else {
          const resolvedImageData = await this.file.resolveLocalFilesystemUrl("file://" + response.path);
          const filename = resolvedImageData.nativeURL.substring(resolvedImageData.nativeURL.lastIndexOf('/') + 1);
          const path = resolvedImageData.nativeURL.substring(0, resolvedImageData.nativeURL.lastIndexOf('/') + 1);
          const base64Image = await this.file.readAsDataURL(path, filename);

          data.nativeURL = resolvedImageData.nativeURL;
          data.base64Image = base64Image;
        }

        resolve(data);
      }, (err) => {
        data.cancelled = true;
        resolve(data);
      });
    })
  }

  getGDGeolocation(): Promise<GDIGeolocationCamera> {
    return new Promise((resolve) => {
      let data = {
        camera: {
          nativeURL: "",
          base64Image: ""
        },
        geolocation: {
          latitude: 0,
          longitude: 0,
          mock: false,
        },
        cancelled: false
      }

      greatdayplugin.getLocation((response) => {
        data.geolocation.latitude = response.latitude;
        data.geolocation.longitude = response.longitude;
        data.geolocation.mock = response.mock;
        resolve(data);
      }, (err) => {
        data.cancelled = true;
        resolve(data);
      });
    })
  }

  getGDGeolocationCamera(): Promise<GDIGeolocationCamera> {
    return new Promise((resolve, reject) => {
      let data = {
        camera: {
          nativeURL: "",
          base64Image: ""
        },
        geolocation: {
          latitude: "",
          longitude: "",
          mock: false,
        },
        cancelled: false
      }

      greatdayplugin.getLocationCamera("img_gd", this.quality, this.maxSize, async (response: ResponseGeolocationCameraRadiusPlugin) => {
        console.log('TCL: getGDGeolocationCamera', response);
        if (response.native) {
          const cameraDevice = await this.cameraDevice({ sourceType: this.camera.PictureSourceType.CAMERA, cameraDirection: this.camera.Direction.FRONT });
          data.camera.nativeURL = cameraDevice.nativeUrl;
          data.cancelled = cameraDevice.cancelled;
        } else {
          const resolvedImageData = await this.file.resolveLocalFilesystemUrl("file://" + response.path);
          const filename = resolvedImageData.nativeURL.substring(resolvedImageData.nativeURL.lastIndexOf('/') + 1);
          const path = resolvedImageData.nativeURL.substring(0, resolvedImageData.nativeURL.lastIndexOf('/') + 1);
          const base64Image = await this.file.readAsDataURL(path, filename);

          data.camera.nativeURL = resolvedImageData.nativeURL;
          data.camera.base64Image = base64Image;
        }

        data.geolocation.latitude = response.latitude;
        data.geolocation.longitude = response.longitude;
        data.geolocation.mock = response.mock;

        resolve(data);
      }, (err) => {
        data.cancelled = true;
        resolve(data);
      });
    })
  }

  getLocationRadiusCamera(workLocation: string, showAddress = false): Promise<GDIGeolocationCamera> {
    return new Promise((resolve) => {
      let data = {
        camera: {
          nativeURL: "",
          base64Image: ""
        },
        geolocation: {
          latitude: "",
          longitude: "",
          mock: false,
          address: ""
        },
        cancelled: false
      }

      // label for maps
      const label1 = this.translate.instant('Is the attendance location point correct?');
      const label2 = this.translate.instant('GPS must have High Accuracy enabled to record Attendance');

      greatdayplugin.getLocationRadiusCamera("img_gd", this.quality, this.maxSize, workLocation, label1, label2, showAddress, async (response: ResponseGeolocationCameraRadiusPlugin) => {
        if (response.native) {
          const cameraDevice = await this.cameraDevice({ sourceType: this.camera.PictureSourceType.CAMERA, cameraDirection: this.camera.Direction.FRONT });
          data.camera.nativeURL = cameraDevice.nativeUrl;
          data.camera.base64Image = cameraDevice.base64Image;
          data.cancelled = cameraDevice.cancelled;
        } else {
          // get return from camera greatday plugin
          const resolvedImageData = await this.file.resolveLocalFilesystemUrl("file://" + response.path);
          const filename = resolvedImageData.nativeURL.substring(resolvedImageData.nativeURL.lastIndexOf('/') + 1);
          const path = resolvedImageData.nativeURL.substring(0, resolvedImageData.nativeURL.lastIndexOf('/') + 1);
          const base64Image = await this.file.readAsDataURL(path, filename);
          data.camera.nativeURL = resolvedImageData.nativeURL;
          data.camera.base64Image = base64Image;
        }

        data.geolocation.latitude = response.latitude;
        data.geolocation.longitude = response.longitude;
        data.geolocation.address = response.address;
        data.geolocation.mock = response.mock;
        resolve(data);
      }, (err) => {
        data.cancelled = true;
        resolve(data);
      });
    })
  }

  getCustomGeolocation(label1: string, label2: string, language: string, location: string): Promise<GDIGeolocationCamera> {
    return new Promise((resolve, reject) => {
      let data = {
        camera: {
          nativeURL: "",
          base64Image: ""
        },
        geolocation: {
          latitude: 0,
          longitude: 0,
          mock: false,
        },
        cancelled: false
      }

      greatdayplugin.getLocationLabelLanguageRadius(label1, label2, language, location, (response) => {
        data.geolocation.latitude = response.latitude;
        data.geolocation.longitude = response.longitude;
        data.geolocation.mock = response.mock;
        resolve(data);
      }, (err) => {
        data.cancelled = true;
        resolve(data);
      });
    })
  }

  async cameraDevice(opt: CameraOptions) {
    let response = {
      cancelled: false,
      nativeUrl: "",
      base64Image: ""
    }

    const options: CameraOptions = {
      quality: opt.quality || 80,
      destinationType: this.camera.DestinationType.FILE_URI,
      sourceType: opt.sourceType ? this.camera.PictureSourceType.CAMERA : this.camera.PictureSourceType.PHOTOLIBRARY,
      allowEdit: opt.allowEdit || false,
      encodingType: this.camera.EncodingType.JPEG,
      targetWidth: opt.targetWidth || 500,
      targetHeight: opt.targetHeight || 500,
      saveToPhotoAlbum: false,
      cameraDirection: opt.cameraDirection || 0,
      correctOrientation: true
    }

    try {
      const imageData = await this.camera.getPicture(options);
      const resolvedImageData = await this.file.resolveLocalFilesystemUrl(imageData);
      const filename = resolvedImageData.nativeURL.substring(resolvedImageData.nativeURL.lastIndexOf('/') + 1);
      const path = resolvedImageData.nativeURL.substring(0, resolvedImageData.nativeURL.lastIndexOf('/') + 1);
      const base64Image = await this.file.readAsDataURL(path, filename);
      response.base64Image = base64Image;
      response.nativeUrl = imageData;
    } catch (error) {
      response.cancelled = true;
    }

    return response;
  }

}



// WEBPACK FOOTER //
// ./src/native/greatday-plugin.native.ts